import { render, staticRenderFns } from "./retiradaCaixa.vue?vue&type=template&id=63731106&scoped=true&"
import script from "./retiradaCaixa.vue?vue&type=script&lang=js&"
export * from "./retiradaCaixa.vue?vue&type=script&lang=js&"
import style0 from "./retiradaCaixa.vue?vue&type=style&index=0&id=63731106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63731106",
  null
  
)

export default component.exports